import React, { useEffect, useState } from "react";

import { endpoint } from "../../common/constant";
import { AGridColDef } from "../../common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { LastUpdatedDetails } from "../../employeeManagement/userProfile/helper";
import { fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";

const BatchLogs = ({ batchDetails }) => {
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchLogs();
  }, [currentPage]);

  const fetchLogs = async () => {
    setIsLoading(true);

    const res = await fetchAllPromisedData(
      `${endpoint?.viewEditBatch.getBatchAuditLogs}/${batchDetails?.id}?offset=${currentPage}&limit=16`
    );

    if (res?.batchAuditList) {
      setRows(res.batchAuditList);
      setTotalRows(res.totalRecords);
    }

    setIsLoading(false);
  };

  const columns = [
    new AGridColDef("event", "Event").renderCellComponent((params) =>
      params?.value ? (
        <div className="ellipsis-text-container">{params?.value}</div>
      ) : (
        <div className="m-auto">-</div>
      )
    ),

    new AGridColDef("value", "Value").renderCellComponent((params) =>
      params?.value ? (
        <div className="ellipsis-text-container">{params?.value}</div>
      ) : (
        <div className="m-auto">-</div>
      )
    ),

    new AGridColDef("updatedOn", "Updated On").renderCellComponent((params) =>
      params?.value ? (
        <div className={`ellipsis-text-container`}>
          {params?.value ? LastUpdatedDetails(params?.value) : "-"}
        </div>
      ) : (
        <div className="m-auto">-</div>
      )
    ),

    new AGridColDef("updatedBy", "Updated By")
      .columnAlign("center")
      .renderCellComponent((params) => <div>{params.value || "-"}</div>),
  ];

  const nextButtonHandler = (pageNum) => {
    setCurrentPage(pageNum);
  };

  return (
    <div style={{ width: "70vw", height: "70vh" }}>
      <ADataGrid
        removeWrapperContainer
        rows={rows}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        nextButtonHandler={nextButtonHandler}
        loading={isLoading}
        rowCount={totalRows}
        height="100%"
        pageSize="16"
      />
    </div>
  );
};

export default BatchLogs;
